import { DirectionsRoute } from './directions';
import { GeoCoordinate, Trackable, TrackableAssetState } from './tracking';

export interface Address {
  country: string;
  locality: string;
  postcode: string;
  state: string | null;
  streetName: string;
  streetNumber: string;
  subLocality: string | null;
  subPremise: string | null;
}

export interface JobTask {
  taskReference: string;
  taskSequence: number;
}

export interface Route {
  deliveryRunReference: string;
  directions: DirectionsRoute | null;
  runStatus: RunStatus;
  routeStops: RouteStop[];
  scheduledStartDateTimeUtc: Date;
  trackable: Trackable;
  travelledPath: TrackableAssetState[];
}

export interface RouteStop {
  address: Address;
  arrivalDateTimeUtc: Date | null;
  consignmentReference: string;
  departureDateTimeUtc: Date | null;
  entranceLocation: GeoCoordinate;
  formattedAddress: string;
  isComplete: boolean;
  location: GeoCoordinate;
  runJobType: RunJobType;
  scheduledArrivalDateTimeUtc: Date | null;
  scheduledDepartureDateTimeUtc: Date | null;
  scheduledTimeOnSiteInMinutes: number;
  sequence: number;
  tasks: JobTask[];
}

export enum RunStatus {
  Activated = 'Activated',
  Enroute = 'Enroute',
  Completed = 'Completed',
  Closed = 'Closed',
  Cancelled = 'Cancelled'
}

export enum RunJobType {
  Start = 'Start',
  Collection = 'Collection',
  Delivery = 'Delivery',
  End = 'End'
}
